import * as yup from 'yup'; // for everything
import { yupToFormErrors } from 'formik';

export const schema = yup.object().shape({
  code: yup.string().required(),
  description: yup.string(),
  assetClass: yup.object().shape({
    value: yup.string().required(),
    label: yup.string(),
  }),
});
